import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import styles from './search-input.module.scss';

interface ISearchInputProperties {
  placeholder?: string;
  onSubmit?: (searchText: string) => void;
  onClear?: () => void;
}

function SearchInput({ placeholder = 'search...', onSubmit, onClear }: ISearchInputProperties) {
  const [searchText, setSearchText] = useState<string>('');
  const [showHelpDialog, setShowHelpDialog] = useState<boolean>(false);

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(searchText);
    }
  };

  const handleClear = () => {
    setSearchText('');
    if (onClear) {
      onClear();
    }
  };

  return (
    <div className={styles.searchInputContainer}>
      <div className="p-inputgroup">
        <InputText
          placeholder={placeholder}
          value={searchText}
          onChange={(event) => setSearchText(event.target.value)}
        />
        {searchText && (
          <Button
            icon="pi pi-times"
            className={`p-button-text p-button-sm ${styles.clearButton}`}
            onClick={handleClear}
            title="Clear search"
          />
        )}
        {!searchText && (
          <Button
            icon="pi pi-info-circle"
            className={`p-button-text p-button-sm ${styles.infoButton}`}
            onClick={() => setShowHelpDialog(true)}
            title="Search help"
          />
        )}
        <Button icon="pi pi-search" className="p-button-primary" onClick={handleSubmit} />
      </div>

      <Dialog
        header="Search Instructions"
        visible={showHelpDialog}
        style={{ width: '50vw' }}
        onHide={() => setShowHelpDialog(false)}
        modal
        closable
      >
        <div className={styles.helpContent}>
          <p>Use the following operators to refine your search:</p>

          <table className={styles.operatorTable}>
            <thead>
              <tr>
                <th>Operator</th>
                <th>Description</th>
                <th>Example</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>AND</strong>
                </td>
                <td>Finds rows where all terms are present</td>
                <td>
                  <code>apple AND banana</code>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>OR</strong>
                </td>
                <td>Finds rows where any term is present</td>
                <td>
                  <code>apple OR banana</code>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>AND NOT</strong>
                </td>
                <td>Finds rows where the first term is present but not the second</td>
                <td>
                  <code>apple AND NOT banana</code>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>NEAR</strong>
                </td>
                <td>Finds rows where terms are close together (within ~50 words)</td>
                <td>
                  <code>apple NEAR banana</code>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>" (quotes)</strong>
                </td>
                <td>Searches for exact phrases</td>
                <td>
                  <code>"organic honey"</code>
                </td>
              </tr>
            </tbody>
          </table>
          <p>
            <b>Note: </b> To search dates, use yyyy-mm-dd formats.
          </p>
        </div>
      </Dialog>
    </div>
  );
}

export default SearchInput;
